<template>
  <div class="card main-card mt-2">
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs nav-fill">
        <li class="nav-item hoverPointer" @click="tabIndex = 0" data-test-hook="owner-info-tab-email-search-result">
          <a class="nav-link" :class="isActive(0)">Owner Information</a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      <div v-if="tabIndex == 0">
        <OwnerInformationTab :value="value" />
      </div>
    </div>

    <div class="card-footer">
      <span id="impersonate-email">
        <button
          type="button"
          class="btn btn-primary mt-2"
          @click="ImpersonateEmail()"
          :disabled="!hasAssociatedAccount(value)"
          data-toggle="tooltip"
          :title="hasAssociatedAccount(value) ? '' : 'No Owner Account'"
          data-test-hook="impersonate-button-email-search-result"
        >
          Impersonate User
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import OwnerInformationTab from '@/components/Admin/OwnerInformationTab'
import { mapState } from 'vuex'

export default {
  components: { OwnerInformationTab },
  props: ['value'],
  data() {
    return {
      tabIndex: 0
    }
  },
  computed: {
    ...mapState({
      currentAppConfig: state => state.application.currentAppConfig
    })
  },
  methods: {
    showDestinationOrgSearchModal() {
      this.openModal('destination-org-search' + this.value.organizationId)
    },
    ImpersonateEmail() {
      // this.$store.dispatch('apparatusReset')
      this.$store.dispatch('clearNotificationApparatuses')
      this.$store.dispatch('setEmail', { email: this.value.ownerInformation.emails[0], userId: this.value?.userId })
    },
    isActive(index) {
      if (index === this.tabIndex) {
        return 'active'
      }
      return ''
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch('getOwnerApparatuses', this.value.organizationId).catch(error => {
          if (error.response.data.status == 401) {
            this.$store.dispatch('displayToast', {
              title: this.$t('xError'),
              message: 'Your session has expired, please re-log in.',
              variant: 'danger'
            })
            this.forceSignOut()
          }
        })
      }
    }
  },
  mounted() {
    if (!this.currentAppConfig) this.$store.dispatch('getApplicationConfiguration', 'Any')
    if (this.value) {
      this.$store.dispatch('getOwnerApparatuses', this.value.organizationId).catch(error => {
        if (error.response.data.status == 401) {
          this.$store.dispatch('displayToast', {
            title: this.$t('xError'),
            message: 'Your session has expired, please re-log in.',
            variant: 'danger'
          })
          this.forceSignOut()
        }
      })
    }
  }
}
</script>

<style scoped>
.main-card {
  box-shadow: 0px -3px 20px rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  border: none;
}
</style>
